import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";
import { FloatingChatToggleButton } from "./Styles";
import { ReactComponent as CollapseIcon } from "../../assets/svg/collapse-chat-bot.svg";
import { selectChatStreaming } from "../../store/selector";

const FloatingChatToggleButtonComponent = ({ onFloatingChatToggle }) => {
  const { t } = useTranslation();
  const isStreaming = useSelector(selectChatStreaming);

  const handleFloatingChatToggle = () => {
    if (isStreaming) {
      return;
    }
    onFloatingChatToggle();
  };

  return (
    <Tooltip
      title={t(isStreaming ? "ai_chat_bot.move_to_floating_chat_streaming" : "ai_chat_bot.move_to_floating_chat")}
      placement="bottom"
    >
      <FloatingChatToggleButton onClick={handleFloatingChatToggle} disabled={isStreaming}>
        <CollapseIcon />
      </FloatingChatToggleButton>
    </Tooltip>
  );
};
export { FloatingChatToggleButtonComponent };
